import {
  API,
  PageableResponse,
  ProductDetailModel,
  ProductListItemModel,
  ProductModel,
} from "@akc/biz-api";

export interface HotRankDetailModel {
  //榜单编号
  rankNo?: string;
  //榜单名称
  rankName?: string;
  //前台3级类目ID
  categoryId?: string;
  //前台2级类目ID
  categoryTwoId?: string;
  //前台1级类目名称
  categoryOneName?: string;
  categoryOneId?: string;
  //商品列表
  // productList?: ProductDetailModel[];
  productList?: ProductModel[] | ProductDetailModel[] | any;

  isHot?: boolean;
}

// 新榜单商品接口
export interface HotRankPrdListRsp {
  hasNext?: boolean;
  pageSize?: number;
  result?: ProductModel[];
}
// 榜单详情信息（不包含商品列表）
export interface RankDetailInfoModel {
  //榜单编号
  rankNo?: string;
  //榜单名称
  rankName?: string;
  //榜单描述
  desc?: string;
  //榜单排序
  rankSort?: number;
  //榜单KV图
  rankImg?: string;
  //置顶标识
  topFlag?: number;
  //指定权重
  specifyWeight?: number;
  //类目榜单标识
  categoryRankFlag?: boolean;
}

// 榜单商品列表模型
export interface RankProductListModel {
  //榜单编号
  rankNo?: string;
  //榜单名称
  rankName?: string;
  //前台3级类目ID
  categoryId?: string;
  //前台2级类目ID
  categoryTwoId?: string;
  //前台1级类目ID
  categoryOneId?: string;
  //商品列表
  productList?: ProductModel[] | ProductDetailModel[] | any;
}

// 一级tab扩展数据结构（支持两级tab）
export interface CategoryHotRankTabVO {
  //一级类目ID
  categoryId?: string;
  //类目名称
  categoryName?: string;
  //类目二级名称
  subCategoryName?: string;
  //类目场景 1=小于10个的标签榜单 2=类目榜单 3=大于等于10个的标签榜单 4=单个榜单
  categoryScene?: number;
  //单个榜单名称
  singleRankName?: string;
  //单个榜单No
  singleRankNo?: string;
  //是否类目榜
  categoryRankClassFlag?: boolean;
  //二级tab列表
  tabItemVOList?: TabItemVO[];
}

export interface TabItemVO {
  //二级tabID
  tabCode?: string;
  //二级tab名称
  tabName?: string;
}

//榜单详情（还是老接口，但是不再包含商品，仅榜单信息）
export const hotRankDetail = async params => {
  return API.post<RankDetailInfoModel>({
    hostID: "h5shop",
    path: "/api/mshop/mshop-aggr-prod/outer/category/hotRankDetail",
    body: params,
  });
};

//查询榜单列表
export const getHotRankList = async params => {
  return API.post<PageableResponse<HotRankDetailModel[]>>({
    hostID: "h5shop",
    path: "/api/mshop/mshop-aggr-prod/outer/category/hotRankList",
    body: params,
  });
};

//榜单类目查询，一级、二级类目一次性返回
export const hotRankCategoryList = async () => {
  return API.post<CategoryHotRankTabVO[]>({
    hostID: "h5shop",
    path: "/api/mshop/mshop-aggr-prod/outer/category/hotRankCategoryList",
  });
};

//单榜单商品列表接口（新接口）
export const hotRankProductList = async params => {
  return API.post<HotRankPrdListRsp>({
    hostID: "h5shop",
    path: "/api/mshop/mshop-aggr-prod/outer/category/hotRankProductList",
    body: params,
  });
};
